import _ from 'lodash';
import moment from 'moment';

class BusinessProducts {
	constructor() {
		this.products = [
			{ moisPerSim: 0, dataPerSimGb: 5, priceInEuros: 5, dataCheaperUpdateGb: 7.4, moisCheaperUpdate: 136 },
			{ moisPerSim: 0, dataPerSimGb: 10, priceInEuros: 8, dataCheaperUpdateGb: 15.6, moisCheaperUpdate: 136 },
			{ moisPerSim: 0, dataPerSimGb: Infinity, priceInEuros: 15, dataCheaperUpdateGb: Infinity, moisCheaperUpdate: 91 },
			{ moisPerSim: 300, dataPerSimGb: 5, priceInEuros: 11, dataCheaperUpdateGb: 7.4, moisCheaperUpdate: 368 },
			{ moisPerSim: 300, dataPerSimGb: 10, priceInEuros: 14, dataCheaperUpdateGb: 14.0, moisCheaperUpdate: 368 },
			{ moisPerSim: 300, dataPerSimGb: Infinity, priceInEuros: 19, dataCheaperUpdateGb: Infinity, moisCheaperUpdate: 345 },
			{ moisPerSim: 600, dataPerSimGb: 5, priceInEuros: 14, dataCheaperUpdateGb: 7.4, moisCheaperUpdate: 714 },
			{ moisPerSim: 600, dataPerSimGb: 10, priceInEuros: 17, dataCheaperUpdateGb: 13.2, moisCheaperUpdate: 714 },
			{ moisPerSim: 600, dataPerSimGb: Infinity, priceInEuros: 21, dataCheaperUpdateGb: Infinity, moisCheaperUpdate: 668 },
			{ moisPerSim: 1200, dataPerSimGb: 5, priceInEuros: 19, dataCheaperUpdateGb: 6.6, moisCheaperUpdate: Infinity },
			{ moisPerSim: 1200, dataPerSimGb: 10, priceInEuros: 21, dataCheaperUpdateGb: 12.4, moisCheaperUpdate: Infinity },
			{ moisPerSim: 1200, dataPerSimGb: Infinity, priceInEuros: 24, dataCheaperUpdateGb: Infinity, moisCheaperUpdate: Infinity }
		];

		this.dataDisplayStrings = {
			5: '5gt',
			10: '10gt',
			Infinity: 'Rajaton data'
		};

		this.initialCostPerSimEuros = 2;
		this.voiceMailCostPerSimEuros = 1.25;
		this.unlimitedDataCostPerSimEuros = 14;
	}

	// This data format should be deprecated, esp. when refactoring matrix.
	// first key voice size, second key data size
	// Result should look like
	// [
	//   {5: 5,  10: 8,  Infinity: 15},
	//   {5: 11, 10: 14, Infinity: 19},
	//   {5: 14, 10: 17, Infinity: 21},
	//   {5: 19, 10: 21, Infinity: 24}
	// ];
	// getPricesForMatrix() {
	//   const matrixPrices = _.map(this.getPackageOptionsMois(), (moi) => {
	//     const productsWithSameMois = _.filter(this.products, (product) => product.moisPerSim === moi);
	//
	//     // Gets row for current package size (mois). eg. returns something like {5: 5,  10: 8,  Infinity: 15}
	//     return _.reduce(productsWithSameMois, (result = {}, product) => {
	//       result[product.dataPerSimGb] = product.priceInEuros;
	//       return result;
	//     }, {});
	//   });
	//
	//   return matrixPrices;
	// }

	getEstimate = (usedAmount, days, periodLength) => {
		// Currently brutal linear interpolation based on average daily consumption.
		const dailyConsumptionAverage = usedAmount / days;
		return parseInt(dailyConsumptionAverage * periodLength, 10);
	};

	getWarningValue = (dataPerSim, moisPerSim, simCount, type) => {
		let limit = 0;

		if (type === 'data') {
			limit = this.getCheaperUpdateLimitData(dataPerSim, moisPerSim);
		} else if (type === 'voice') {
			limit = this.getCheaperUpdateLimitVoice(dataPerSim, moisPerSim);
		}
		return limit * simCount;
	};

	getEstimatePeriodLength = (start, end) => {
		const startDate = moment(start, 'YYYY-MM-DD');
		const endDate = moment(end, 'YYYY-MM-DD');
		const now = moment();
		const passed = now < endDate ? now : endDate;

		return passed.diff(startDate, 'days');
	};

	// Return all possible unique package moi-sizes eg [0, 300, 600, 1200]
	getPackageOptionsMois = () => _.uniq(_.map(this.products, 'moisPerSim'));

	// Return all possible unique package moi-sizes eg [5, 10, Infinity]
	getPackageOptionsData = () => _.uniq(_.map(this.products, 'dataPerSimGb'));

	getDataDisplayStrings = () => this.dataDisplayStrings;

	dataPerSimNumeric = (dataPerSim) => (Number(dataPerSim) === Infinity || dataPerSim === 'unlimited' ? Infinity : parseInt(dataPerSim, 10));

	// TODO: needs tests
	getProductRow = (dataPerSim, moisPerSim) => {
		const dataPerSimNumber = this.dataPerSimNumeric(dataPerSim);
		const moisPerSimNumber = parseInt(moisPerSim, 10);

		if (_.isNumber(dataPerSimNumber) && _.isNumber(moisPerSimNumber)) {
			return _.find(this.products, { moisPerSim: moisPerSimNumber, dataPerSimGb: dataPerSimNumber });
		}
		return null;
	};

	isUnlimited = (packageSize) => _.includes([Infinity, 'unlimited', 'Rajaton data'], packageSize);

	getDataPackageTotal = (dataPerSim, sims) => {
		if (this.isUnlimited(dataPerSim)) {
			return Infinity;
		}
		return parseInt(dataPerSim, 10) * parseInt(sims, 10);
	};

	getMoisPackageTotal = (moisPerSim, sims) => parseInt(moisPerSim, 10) * parseInt(sims, 10);

	getPricePerSim = (dataPerSim, moisPerSim) => {
		const dataPerSimNumber = this.dataPerSimNumeric(dataPerSim);
		const moisPerSimNumber = parseInt(moisPerSim, 10);

		if (_.isNumber(dataPerSimNumber) && _.isNumber(moisPerSimNumber)) {
			const product = _.find(this.products, { moisPerSim: moisPerSimNumber, dataPerSimGb: dataPerSimNumber });
			return _.has(product, 'priceInEuros') ? product.priceInEuros : null;
		}

		return null;
	};

	// Return "unlimited" for unlimited data, otherwise gb amount as string with unit 'gb'
	dataPerSimAsString = (dataPerSim) => {
		if (String(dataPerSim).indexOf('gt') === -1) {
			return Number(dataPerSim) === Infinity ? 'unlimited' : `${dataPerSim}gt`;
		}

		return dataPerSim;
	};

	isUnlimitedData = (dataPerSim) => dataPerSim === Infinity || dataPerSim === 'unlimited' || dataPerSim === 'Rajaton data';

	getDataPackageSizeUIString = (dataPerSim) => {
		if (this.isUnlimitedData(dataPerSim)) {
			return 'Rajaton';
		}
		return `${dataPerSim} gt`;
	};

	getSimInitialPrice = () => this.initialCostPerSimEuros;

	getSimVoiceMailPrice = () => this.voiceMailCostPerSimEuros;
	getSimUnlimitedDataPrice = () => this.unlimitedDataCostPerSimEuros;

	getInitialCostsTotal = (simQuantity) => this.getSimInitialPrice() * simQuantity;

	getMonthlyCost = (dataPerSim, moisPerSim, quantity) => this.getPricePerSim(dataPerSim, moisPerSim) * quantity;

	// Returns first month price (monthly cost + initial cost)
	getFirstMonthCost = (dataPerSim, moisPerSim, quantity) => {
		const monthlyCost = this.getMonthlyCost(dataPerSim, moisPerSim, quantity);
		const initialCosts = this.getInitialCostsTotal(quantity);

		return monthlyCost + initialCosts;
	};

	// TODO: needs tests
	// TODO: Remove hardcoded values for smallest packages, opt for something smarter
	getCheaperUpdateLimitVoice = (dataPerSim, moisPerSim) => {
		const item = this.getProductRow(dataPerSim, moisPerSim);
		return _.has(item, 'moisCheaperUpdate') ? item.moisCheaperUpdate : 136;
	};

	// TODO: needs tests
	// TODO: Remove hardcoded values for smallest packages, opt for something smarter
	getCheaperUpdateLimitData = (dataPerSim, moisPerSim) => {
		const item = this.getProductRow(dataPerSim, moisPerSim);
		return _.has(item, 'dataCheaperUpdateGb') ? item.dataCheaperUpdateGb : 7.4;
	};
}

const businessProducts = new BusinessProducts();
Object.freeze(businessProducts);

export default businessProducts;
